module.exports = __webpack_public_path__ + "static/media/pendente-solid.6a3d2dbf.png";